import { SpocContextChangeResponse } from '../api';
import { Action } from 'redux';

export const SET_RESERVE_LIST_ID = 'SET_RESERVE_LIST_ID';

export const RESERVE_FETCH_REQUIRED_SPOC_SUCCESS = 'RESERVE_FETCH_REQUIRED_SPOC_SUCCESS';

export const RESERVE_CLEAR_REQUIRED_SPOC = 'RESERVE_CLEAR_REQUIRED_SPOC';

export type SetReserveListId = {
    type: typeof SET_RESERVE_LIST_ID;
    payload: string;
};

export type ReserveClearRequiredSpoc = Action<typeof RESERVE_CLEAR_REQUIRED_SPOC>;
export type ReserveFetchRequiredSpocSuccess = {
    type: typeof RESERVE_FETCH_REQUIRED_SPOC_SUCCESS;
    payload: SpocContextChangeResponse;
};

export type ReserveAction = SetReserveListId | ReserveClearRequiredSpoc | ReserveFetchRequiredSpocSuccess;
